import React from 'react';
import connect from 'Shared/connect';
import { translate } from 'Shared/translate';
import FeedbackButton from 'Shared/Button/Feedback';
import { logout } from '../../action-creators';
import * as styles from './base.scss';
const LogoutBox = ({ logout }) => (React.createElement("div", null,
    React.createElement(FeedbackButton, { type: "button", onClickWithFeedback: (e, activate) => activate(logout()), className: styles.logoutButton }, translate('/Account/MyPages/Logout'))));
export default connect((state) => ({}), (dispatch, ownProps) => ({
    logout: () => dispatch(logout()).then(ownProps.close),
}))(LogoutBox);
